import { useTheme } from '../context/ThemeContext';
import logoLight from '../assets/logo_light.png';
import logoDark from '../assets/logo_dark.png';

interface LogoProps {
  /** Size with a height class (e.g. `h-8`); the width follows the image. */
  className?: string;
}

/**
 * The SolanIQ wordmark - the same artwork as the mobile app header
 * (mobile/assets): black + orange on light, white + cyan on dark.
 */
export function Logo({ className = 'h-8' }: LogoProps) {
  const { theme } = useTheme();
  return (
    <img
      src={theme === 'dark' ? logoDark : logoLight}
      alt="SolanIQ"
      className={`w-auto select-none ${className}`}
      draggable={false}
    />
  );
}
